import { apiFetchJson } from "@/utils/apiFetch";

const BASE_API_URL = import.meta.env.VITE_API_URL;

export type TrialNewsRunStatus = "PENDING" | "RUNNING" | "COMPLETE" | "ERROR";

export interface TrialNewsRun {
  id: string;
  role: string;
  status: TrialNewsRunStatus;
  reasoning_effort?: string;
  summary_markdown?: string;
  report?: unknown;
  model_name?: string;
  error?: string;
  created_at: string;
  completed_at: string | null;
}

export interface TrialNewsLatestResponse {
  latest: TrialNewsRun | null;
  active_run: TrialNewsRun | null;
}

export interface TrialNewsRefreshResponse {
  run: TrialNewsRun;
  queued: boolean;
}

export const trialNewsService = {
  getLatest: async (
    trialId: string,
    role: string,
  ): Promise<TrialNewsLatestResponse> => {
    return apiFetchJson<TrialNewsLatestResponse>(
      `${BASE_API_URL}/trialnews/${trialId}/latest/?role=${encodeURIComponent(role)}`,
    );
  },
  refresh: async (
    trialId: string,
    role: string,
  ): Promise<TrialNewsRefreshResponse> => {
    return apiFetchJson<TrialNewsRefreshResponse>(
      `${BASE_API_URL}/trialnews/${trialId}/refresh/`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ role }),
      },
    );
  },
  getRun: async (trialId: string, runId: string): Promise<TrialNewsRun> => {
    return apiFetchJson<TrialNewsRun>(
      `${BASE_API_URL}/trialnews/${trialId}/runs/${runId}/`,
    );
  },
};
